import { IFertiliserStock, IManureStock, IManureType, IOmniaHttpService, ISeedStock, isUndefinedOrNull, omniaResolve, RegionId, setDates, setupManureTypesForRegion, SharedDataService } from "../omnia"
import { IAllStocks, IMmExport } from "../types"

interface IServiceData extends Omit<IAllStocks, "ManureTypes"> {

    ManureExports: IMmExport[];

}

export class StocksLoader {

    private _holdingId: number
    private _year: number
    private _region: RegionId

    private _seedStocks: ISeedStock[] = []

    private _fertiliserStocks: IFertiliserStock[] = []

    private _manureTypes: IManureType[] = []

    private _manureStocks: IManureStock[] = []
    private _manureExports: IMmExport[] = []


    constructor(private ohttp: IOmniaHttpService, private sharedData: SharedDataService) {

    }


    public load(holdingId: number, year: number, region: RegionId): ng.IPromise<any> {

        return this.getServiceData(year).then(serviceData => {

            this._holdingId = holdingId
            this._year = year
            this._region = region

            this._seedStocks = serviceData.SeedStocks;

            this._manureTypes = this.sharedData.getManureTypes(region)
            this._manureStocks = serviceData.ManureStocks;
            this._manureExports = serviceData.ManureExports;

            setDates(this._manureStocks, ["ImportDate"], true);
            setDates(this._manureExports, ["Date"], true);

            this._fertiliserStocks = serviceData.FertiliserStocks;

            this.setupStocks(serviceData, this._manureTypes)

        });

    }

    private setupStocks(stocks: Omit<IAllStocks, "ManureTypes">, manureTypes: IManureType[]) {

        const { crops, varieties, fertiliserProducts } = this.sharedData

        stocks.SeedStocks = stocks.SeedStocks || [];
        stocks.SeedStocks.forEach(ss => {
            ss.Crop = crops.find(c => c.CropId == ss.CropId)
            ss.Variety = varieties.find(v => v.CropVarietyId == ss.VarietyId)
        });

        stocks.FertiliserStocks = stocks.FertiliserStocks || [];
        stocks.FertiliserStocks.forEach(fs => {
            fs.StandardProduct = fertiliserProducts.find(fp => fp.FertiliserProductId == fs.StandardProductId)
        });

        stocks.ManureStocks = stocks.ManureStocks || [];
        stocks.ManureStocks.forEach(ms => {
            ms.ManureType = manureTypes.find(mt => mt.ManureTypeId == ms.ManureTypeId);
            ms.NvzManureType = manureTypes.find(mt => mt.ManureTypeId == ms.NvzManureTypeId);
        });

        setDates(stocks.ManureStocks, ["ImportDate"], true)

    }

    private getServiceData(year: number) {

        const url = `/api/stocks/v1/data?year=${year}`

        return this.ohttp.get(url).then<IServiceData>(r => r.data)

    }

    getStocksForYear(year: number): ng.IPromise<IAllStocks> {

        const url = "/api/stocks/holding/" + this._holdingId + "/year/" + year;

        return this.ohttp.get(url).then(r => {

            const stocks = <IAllStocks>r.data

            if (stocks) {

                const manureTypes = stocks.ManureTypes ?? this._manureTypes

                this.setupStocks(stocks, manureTypes);

                stocks.SeedStocks = stocks.SeedStocks.filter(s => !!s.Crop);
                stocks.FertiliserStocks = stocks.FertiliserStocks.filter(s => s.Custom || (!!s.StandardProduct));
                stocks.ManureStocks = stocks.ManureStocks.filter(s => s.Custom || (!!s.ManureType));

            }

            return stocks;

        })


    }

    getSeedStocks(): ISeedStock[] {
        return this._seedStocks ? this._seedStocks.slice() : [];
    }

    getFertiliserStocks(): IFertiliserStock[] {
        return this._fertiliserStocks ? this._fertiliserStocks.slice() : [];
    }

    getManureTypes() {
        return this._manureTypes
    }

    getManureTypesForYear(year: number): ng.IPromise<IManureType[]> {

        if (isUndefinedOrNull(year) || (this._year == year)) {
            return omniaResolve(this._manureTypes)
        }

        const url = `/api/stocks/manure/types/holding/${this._holdingId}/year/${year}`

        return this.ohttp.get(url).then(r => r.data ? setupManureTypesForRegion(r.data, this._region) : undefined)

    }

    getManureStocks(): IManureStock[] {
        return this._manureStocks ? this._manureStocks.slice() : [];
    }

    getManureExports(): IMmExport[] {
        return this._manureExports ? this._manureExports.slice() : [];
    }

}
